module.exports = __webpack_public_path__ + "img/client-2.353f81fd.webp";